import { Outlet, useNavigate, useResolvedPath } from "react-router";
import NavStyles from "../Bilet/Bilet.module.css";
import { Button } from "@mui/material";
import { useEffect, useState } from "react";

export default function Pdd() {
  const defState = {
    pdd: false,
    pdd_theme: false,
  };
  const [isActive, setActive] = useState({ ...defState });
  let path = useResolvedPath();
  useEffect(() => {
    const resolvedPath = path.pathname.split("/");
    setActive({ ...defState, [resolvedPath.slice(-1)]: true });
  }, [path.pathname]);
  const navHook = useNavigate();

  const handleNav = (e) => {
    const destanation = e.target.id;
    navHook(destanation);
  };

  return (
    <main>
      <div className={NavStyles.bilet_nav}>
        <Button
          disabled={isActive.pdd}
          onClick={handleNav}
          variant={isActive.pdd ? "contained" : "outlined"}
          id="/pdd">
          Разеделы
        </Button>
        <Button
          disabled={isActive.pdd_theme}
          onClick={handleNav}
          variant={isActive.pdd_theme ? "contained" : "outlined"}
          id="pdd_theme">
          Темы
        </Button>
      </div>
      <Outlet />
    </main>
  );
}
